export function OutlineLightbulbIndifferentIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.67776 16.1345C10.0713 15.4195 10.5703 15.1844 10.8295 14.335C10.9398 13.9655 11.0022 13.5768 11.0022 13.1689C11.0022 10.8079 8.95795 8.92681 6.54418 9.19554C4.70146 9.40188 3.21385 10.9039 3.0219 12.7514C2.96432 13.3081 3.0219 13.8407 3.17546 14.335C3.4298 15.17 3.94326 15.3523 4.35595 16.1633C4.5575 16.5568 4.77824 17.171 4.78304 18.0588H9.21708C9.22188 17.1567 9.45702 16.5424 9.67776 16.1393V16.1345Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M7 17.704V13.3516"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.78784 18.0739V19.5231C4.78784 20.3389 5.45007 21.0011 6.26585 21.0011H7.73907C8.55485 21.0011 9.21708 20.3389 9.21708 19.5231V18.0787C9.21708 18.0787 9.21708 18.0643 9.21708 18.0547H4.78784C4.78784 18.0547 4.78784 18.0691 4.78784 18.0739Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9126 9.91602C17.8886 10.0984 17.8694 10.2951 17.8694 10.5111"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M12.941 4.94336C12.7778 5.27927 12.6771 5.64398 12.6387 6.02788C12.5907 6.49815 12.6387 6.94444 12.7634 7.36672C12.9794 8.06734 13.4161 8.2257 13.7616 8.90712C13.9295 9.24303 14.1263 9.7613 14.1263 10.5099"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M15.9929 3.00001C17.8596 2.99521 19.3712 4.50682 19.376 6.37833"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M17.8695 10.5098V11.7526C17.8695 12.4437 17.3032 13.0003 16.6218 13.0003H15.3741C14.6831 13.0003 14.1265 12.4437 14.1265 11.7526V10.5098"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0022 3L20.998 13.0006"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
